import { sendGoogleEvent } from '@html/_common/utils';

export default class Pagination {
  constructor(category) {
    this.CATEGORY = category;
    this.NUMBER_SELECTOR = '.js-pagination-link--num';
    this.PREVIOUS_SELECTOR = '.js-pagination-link--previous';
    this.NEXT_SELECTOR = '.js-pagination-link--next';
    this.LABEL = 'Pagination';
  }

  init() {
    if (!$('.pagination').length && !$('.scout-pagination').length) {
      return;
    }

    this.initNumberEvents();
    this.initButtonEvents();
  }

  initNumberEvents() {
    $(this.NUMBER_SELECTOR).on('click', (e) => {
      const action = $(e.currentTarget).data('parameter');

      sendGoogleEvent(
        this.CATEGORY,
        action,
        this.LABEL,
        {
          ampEventName: 'serp_pagination_clicked',
          pageNumber: action,
        },
      );
    });
  }

  initButtonEvents() {
    $(`${this.PREVIOUS_SELECTOR}, ${this.NEXT_SELECTOR}`).on('click', (e) => {
      const action = $(e.currentTarget).data('ga');

      sendGoogleEvent(
        this.CATEGORY,
        action,
        this.LABEL,
        {
          ampEventName: 'serp_pagination_clicked',
          pageNumber: action,
        },
      );
    });
  }
}
